// Library methods

// Utils
import { POST, GET } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_CREATE_MERCHANT_ADJUSTMENTS,
    API_FETCH_MERCHANT_ADJUSTMENTS,
    API_GENERATE_ADJUSTMENT_REPORT,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as adjustmentsActions from './adjustments.actions';

// Constants
import {
    FETCH_ADJUSTMENTS_REQUEST,
    GENERATE_ADJUSTMENT_REPORT_REQUEST,
    CREATE_ADJUSTMENT_REQUEST,
} from './adjustments.constants';
import { toast } from 'react-toastify';
import moment from 'moment';
import { takeLatest, put, call } from 'redux-saga/effects';

const getRequestData = payload => {
    const request = {
        pageNo: payload.pageIndex || 1,
        pageSize: payload.pageSize || 10,
        // adjustmentCategory: ['INCORRECT_MDR'],
    };
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }

    if (payload.merchantIds && payload.merchantIds.length) {
        request.merchantIds = payload.merchantIds;
    }
    if (payload.adjustmentCategory && payload.adjustmentCategory.length) {
        request.adjustmentCategory = [payload.adjustmentCategory];
    }
    if (payload.adjustmentType && payload.adjustmentType.length) {
        request.adjustmentType = payload.adjustmentType;
    }
    if (payload.merchantCode) {
        if (request.merchantIds) {
            request.merchantIds.push(payload.merchantCode);
        } else {
            request.merchantIds = [payload.merchantCode];
        }
    }

    return request;
};

const getRequestDataFile = payload => {
    const request = {};
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }

    if (payload.reportFileName) {
        request.reportFileName = payload.reportFileName;
    }
    if (payload.merchantIds && payload.merchantIds.length) {
        request.merchantIds = payload.merchantIds;
    }
    if (payload.adjustmentCategory && payload.adjustmentCategory.length) {
        request.adjustmentCategory = [payload.adjustmentCategory];
    }
    if (payload.adjustmentType && payload.adjustmentType.length) {
        request.adjustmentType = payload.adjustmentType;
    }
    if (payload.merchantCode) {
        request.merchantCode = payload.merchantCode;
    }

    return request;
};

export function* fetchAdjustmentsDetails(actions) {
    yield put(adjustmentsActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(
            POST,
            API_FETCH_MERCHANT_ADJUSTMENTS,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(adjustmentsActions.fetchAdjustmentsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                adjustmentsActions.fetchAdjustmentsError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            adjustmentsActions.fetchAdjustmentsError({
                error: data,
            })
        );
    }
    yield put(adjustmentsActions.hideLoader());
}

export function* generateAdjustmentReport(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const request = getRequestDataFile(payload);
        const { data } = yield call(
            POST,
            API_GENERATE_ADJUSTMENT_REPORT,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(adjustmentsActions.generateReportSuccess(data));
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                adjustmentsActions.generateReportError({
                    error: errorMessage || '',
                })
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            adjustmentsActions.generateReportError({
                error: errorMessage || '',
            })
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* createAdjustment(actions) {
    try {
        const { payload } = actions;
        const request = { ...payload };
        const { data } = yield call(
            POST,
            API_CREATE_MERCHANT_ADJUSTMENTS,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                adjustmentsActions.createAdjustmentSuccess({
                    isLoading: false,
                    data,
                    message: '',
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                adjustmentsActions.createAdjustmentError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data, status } = response;

        if (status !== 401) {
            yield put(
                adjustmentsActions.createAdjustmentError({
                    isLoading: false,
                    message: data.errorMessage,
                })
            );
        }
    }
}

/**
 * WATCHER SAGA
 */
export function* adjustmentsSaga() {
    yield takeLatest(FETCH_ADJUSTMENTS_REQUEST, fetchAdjustmentsDetails);
    yield takeLatest(CREATE_ADJUSTMENT_REQUEST, createAdjustment);
    yield takeLatest(
        GENERATE_ADJUSTMENT_REPORT_REQUEST,
        generateAdjustmentReport
    );
}
